<rt-group
  [class.editable]="editable"
  [class.horizontal]="direction === 'horizontal'"
  [class.vertical]="direction === 'vertical'"
>
  <rt-add-new-button
    *ngIf="editable"
    variant="rounded"
    class="action more"
    [rtcAnalyticsTrack]="analyticsEvent ? analyticsEvent : undefined"
    (click)="onAddClick()"
    iconName="add-circle-outline"
    shape="round"
    size="medium"
    margin-right-small-xx
  >
  </rt-add-new-button>
  <rt-group
    *ngIf="admins.length > 0"
    [class.stacked]="stacked"
    [class.horizontal]="direction === 'horizontal'"
    [class.vertical]="direction === 'vertical'"
    [class.wrap]="multiline"
    [class.grid-vertical-margin]="multiline"
    [ngClass]="'spacing--' + spacing"
    (click)="onAvatarsClick(); stopPropagation($event); $event.preventDefault()"
    class="avatars keep-radius"
  >
    <ng-container *ngIf="!isRole">
      <ng-container *ngFor="let admin of visibleAssignments(); trackBy: trackByAdmin">
        <rt-avatar
          #adminDetailsDropdownOrigin="rtOverlayOrigin"
          rt-overlay-origin
          [rtTooltip]="
            renderAdminTooltip ? renderAdminTooltip(admin) : admin.firstName + ' ' + admin.lastName
          "
          [rtTooltipPosition]="tooltipPosition"
          [rtTooltipMaxWidth]="tooltipMaxWidth"
          [rtTooltipWordWrap]="tooltipWordWrap"
          [type]="!admin.id ? 'icon' : admin.hasAvatar || !admin.initials ? 'image' : 'initials'"
          [size]="avatarSize ? avatarSize : 'base'"
          [shape]="avatarShape ? avatarShape : 'oval'"
          [imageSrc]="admin.photoThumbUrl"
          [isOnline]="admin.isOnline!"
          [initials]="admin.initials"
          [class.cursor-pointer]="withDetailsDropdown"
          (click)="withDetailsDropdown && openDetailsDropdown(admin)"
          iconName="person"
          context="admin"
        >
        </rt-avatar>
        <ng-template
          [origin]="adminDetailsDropdownOrigin"
          [open]="detailsDropdownOpen === admin.id"
          [hasBackdrop]="true"
          (backdropClick)="closeDetailsDropdown()"
          rt-connected-overlay
        >
          <rt-admin-details-dropdown [admin]="$any(admin)"></rt-admin-details-dropdown>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="isRole">
      <rt-avatar
        *ngFor="let admin of visibleAssignments(); trackBy: trackByAdmin"
        [rtTooltip]="$any(admin).name"
        [rtTooltipPosition]="tooltipPosition"
        [rtTooltipMaxWidth]="tooltipMaxWidth"
        [rtTooltipWordWrap]="tooltipWordWrap"
        [type]="'initials'"
        [size]="avatarSize ? avatarSize : 'base'"
        [shape]="avatarShape ? avatarShape : 'oval'"
        [fullName]="$any(admin).name"
        [context]="'admin'"
      >
      </rt-avatar>
    </ng-container>

    <rt-icon-button
      *ngIf="hasMore() && !moreButtonAsCounter"
      size="small"
      shape="round"
      variant="secondary"
      iconName="more-horiz"
      #moreButton
      class="has-more default"
      [rtTooltip]="renderOtherAdminsTooltip ? renderOtherAdminsTooltip(otherAdmins) : null"
      [rtTooltipTemplate]="renderOtherAdminsTooltip ? null : defaultHasMoreTooltipTemplate"
      [rtTooltipPosition]="tooltipPosition"
      [rtTooltipMaxWidth]="tooltipMaxWidth"
      [rtTooltipWordWrap]="tooltipWordWrap"
      (click)="moreClick.emit()"
    >
    </rt-icon-button>

    <rt-avatar
      *ngIf="hasMore() && moreButtonAsCounter"
      [rtTooltip]="renderOtherAdminsTooltip ? renderOtherAdminsTooltip(otherAdmins) : null"
      [rtTooltipTemplate]="renderOtherAdminsTooltip ? null : defaultHasMoreTooltipTemplate"
      [rtTooltipPosition]="tooltipPosition"
      [rtTooltipMaxWidth]="tooltipMaxWidth"
      [rtTooltipWordWrap]="tooltipWordWrap"
      (click)="moreClick.emit()"
      [type]="'custom'"
      [avatarTpl]="counterAvatarTemplate"
    >
    </rt-avatar>
  </rt-group>
</rt-group>

<ng-template #defaultHasMoreTooltipTemplate>
  <div class="tooltip-list">
    <div *ngFor="let admin of otherAdmins; trackBy: trackByAdmin" class="tooltip-list-item">
      {{ $any(admin).name?.length ? $any(admin).name : admin.firstName + ' ' + admin.lastName }}
    </div>
  </div>
</ng-template>

<ng-template #counterAvatarTemplate>
  <div class="avatar-counter">+{{ otherAdmins.length }}</div>
</ng-template>
